// import React, { useEffect, useState } from 'react';
// import ReactApexChart from 'react-apexcharts';
// // import { useManpowerByBranchChartMutation } from '../../features/dashboard/dashboardApiSlice';
// import SelectCountryListByLocation from '../../features/utils/SelectCountryListByLocation';
// import { cleanObjectData } from '../../features/utils/Utils';
// import { useInterviewHiringReportChartMutation } from '../../features/dashboard/dashboardApiSlice';

// const InterviewHiringChart = () => {
//   const [selectedCountryId, setSelectedCountryId] = useState(0);
//   const [selectedLocationId, setSelectedLocationId] = useState(0);
//   const [selectedBranchId, setSelectedBranchId] = useState(0);

//   const [
//     interviewChart,
//     { data: interviewData, isLoading: interviewLoading },
//   ] = useInterviewHiringReportChartMutation();
//   console.log('interviewHiringChart',interviewData);

//   useEffect(() => {
//     callAPI();
//   }, []);

//   useEffect(() => {
//     callAPI();
//   }, [selectedCountryId, selectedLocationId,selectedBranchId]);

//   const callAPI = () => {
//     const data = {
//       country_id: parseInt(selectedCountryId),
//       location_id: parseInt(selectedLocationId),
//       branch_id : parseInt(selectedBranchId),
//     };
//     const dataObj = cleanObjectData(data);
//     interviewChart(dataObj);
//   };

//   const chartData = interviewData?.data;
//   const chartName = 'Interview';

//   const series = ['Hire', 'NoHire'];

//   const getSeriesData = () => {
//     return series.map((series, index) => {
//       if (index === 0) {
//         return {
//           name: series,
//           data: chartData?.map((item) => item[`Hire`] || 0),
//         };
//       }
//       if (index === 1) {
//         return {
//           name: series,
//           data: chartData?.map((item) => item[`NoHire`] || 0),
//         };
//       }
//     });
//   };

//   const options = {
//     chart: {
//       type: 'bar',
//       height: 380,
//       fontFamily: 'Inter var', // Set font family for all text elements
//       // foreColor: '#FFFFFF', // Set color for all text elements to white
//       foreColor: '#000000', //set color for all text elements to black
//       toolbar: {
//         show: false, //Hide the toolbar (menu bar)
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: true,
//         dataLabels: {
//           enabled: true, // Ensure dataLabels is properly defined with enabled property
//           position: 'center',
//         },
//         barHeight: '15px',
//       },
//     },
//     dataLabels: {
//       enabled: true,
//       // formatter: function (val, opts) {
//       //     return opts.w.config.series[opts.seriesIndex]; //Display value
//       // },
//       style: {
//         fontSize: '10px',
//         fontWeight:'',
//         fontFamily: 'Inter var',
//         // colors: ['#FFFFFF'], //color of the data labels
//         colors: ['#fff'], //color of the data labels
        
//       },
//     },
//     stroke: {
//       show: false,
//       width: 1,
//       colors: ['#fff'],
//     },
//     tooltip: {
//       shared: true,
//       intersect: false,
//     },
//     xaxis: {
//       categories: chartData ? chartData.map((item) => item.title) : [],
//       labels: {
//         show: false, //Hide the x-axis labels
//       },
//       axisBorder: {
//         show: true,
//         color: '#9ca3af', //color of x-axis line
//         height: 1,
//       },
//       axisTicks: {
//         show: false,
//         // color: '#6234C1', //color of x-axis ticks
//       },
//     },
//     yaxis: {
//       axisBorder: {
//         show: true,
//         color: '#9ca3af', //color of x-axis line
//         width: 1,
//       },
//     },
//     grid: {
//       show: true,
//       borderColor: '#f3f4f6',
//       xaxis: {
//         lines: {
//           show: true, // Show vertical grid lines
//         },
//       },
//       yaxis: {
//         lines: {
//           show: true, // Show horizontal grid lines
//         },
//       },
//     },
//     colors: ['#5EEE6E', '#F92D51'],
//     // yaxis: {
//     //     labels: {
//     //         style: {
//     //             fontSize: '12px', // Adjust font size of y-axis labels
//     //             fontFamily: 'Poppins',
//     //         },
//     //     },
//     //     grid: {
//     //         show: true, // Show the y-axis gridlines
//     //         borderColor: '#FFFFFF', // Set the color of y-axis gridlines to white
//     //         strokeDashArray: 0, // Optionally, set the strokeDashArray to make gridlines solid
//     //         position: 'back', // Set the grid lines behind the data points
//     //     },
//     // },
//   };

//   const setCountryId = (id) => {
//     setSelectedCountryId(id);
//   };

//   const setLocationId = (id) => {
//     setSelectedLocationId(id);
//   };
//   const setBranchId = (id) => {
//     setSelectedBranchId(id);
//   };

//   return (
// <div>
//       <div className="flex justify-between  p-3">
//         <div>
//           <h1 className="text-black text-[16px] font-sans">{chartName}</h1>
//         </div>
//         <div>
//           {/* Dropdown for country */}
//           {/* <select
//             className=" bg-[#39216B] text-white text-[13px]"
//             value={selectedCountry}
//             onChange={(e) => setSelectedCountry(e.target.value)}
//           >
//             <option value="">Country</option>
//             {countryOptions.map((country, index) => (
//               <option key={index} value={country}>
//                 {country}
//               </option>
//             ))}
//           </select> */}

//           {/* Dropdown for branch */}
//           {/* <select
//             className="bg-[#39216B] text-white text-[13px]"
//             value={selectedBranch}
//             onChange={(e) => setSelectedBranch(e.target.value)}
//           >
//             <option value="">Branch</option>
//             {branchOptions.map((branch, index) => (
//               <option key={index} value={branch}>
//                 {branch}
//               </option>
//             ))}
//           </select> */}

//           {/* Dropdown for department */}
//           {/* <select
//             className="bg-[#39216B] text-white text-[13px]"
//             value={selectedDepartment}
//             onChange={(e) => setSelectedDepartment(e.target.value)}
//           >
//             <option value="">Department</option>
//             {departmentOptions.map((department, index) => (
//               <option key={index} value={department}>
//                 {department}
//               </option>
//             ))}
//           </select> */}

//           {/* Dropdown for last 30 days */}
//           {/* <select
//             className="bg-[#39216B] text-white text-[13px]"
//             value={selectedLast30Days}
//             onChange={(e) => setSelectedLast30Days(e.target.value)}
//           >
//             <option value="">Last 30 Days</option>
//             {last30DaysOptions.map((days, index) => (
//               <option key={index} value={days}>
//                 {days}
//               </option>
//             ))}
//           </select> */}
//           <SelectCountryListByLocation
//             setCountryId={setCountryId}
//             setLocationId={setLocationId}
//             setBranchId={setBranchId}
//             isDaysFilter={false}
//             showCountry={true}
//             showBranch = {true}
//             showLocation={true}
//           />
//         </div>
//       </div>
//       <ReactApexChart
//         options={options}
//         series={getSeriesData()}
//         type="bar"
//         height={380}
//         width={567}
//       />
//     </div>
//   );
// };

// export default InterviewHiringChart;

//for previous and next page as pagination
// import React, { useEffect, useState } from 'react';
// import ReactApexChart from 'react-apexcharts';
// import SelectCountryListByLocation from '../../features/utils/SelectCountryListByLocation';
// import { cleanObjectData } from '../../features/utils/Utils';
// import { useInterviewHiringReportChartMutation } from '../../features/dashboard/dashboardApiSlice';

// const InterviewHiringChart = () => {
//   const [selectedCountryId, setSelectedCountryId] = useState(0);
//   const [selectedLocationId, setSelectedLocationId] = useState(0);
//   const [selectedBranchId, setSelectedBranchId] = useState(0);

//   const [currentPage, setCurrentPage] = useState(1); // Pagination state
//   const itemsPerPage = 5; // Number of items per page

//   const [
//     interviewChart,
//     { data: interviewData, isLoading: interviewLoading },
//   ] = useInterviewHiringReportChartMutation();

//   useEffect(() => {
//     callAPI();
//   }, []);

//   useEffect(() => {
//     callAPI();
//   }, [selectedCountryId, selectedLocationId, selectedBranchId]);

//   const callAPI = () => {
//     const data = {
//       country_id: parseInt(selectedCountryId),
//       location_id: parseInt(selectedLocationId),
//       branch_id: parseInt(selectedBranchId),
//     };
//     const dataObj = cleanObjectData(data);
//     interviewChart(dataObj);
//   };

//   const chartData = interviewData?.data || [];
//   const chartName = 'Interview';

//   const series = ['Hire', 'NoHire'];

//   // Pagination logic: Slice the chart data based on the current page
//   const getPaginatedData = (data) => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     return data.slice(startIndex, endIndex);
//   };

//   // Function to get the data for the current page
//   const paginatedData = getPaginatedData(chartData);

//   // Calculate the total number of pages
//   const totalPages = Math.ceil(chartData.length / itemsPerPage);

//   // Function to get series data based on the paginated data
//   const getSeriesData = () => {
//     return series.map((seriesName, index) => {
//       if (index === 0) {
//         return {
//           name: seriesName,
//           data: paginatedData.map((item) => item[`Hire`] || 0),
//         };
//       }
//       if (index === 1) {
//         return {
//           name: seriesName,
//           data: paginatedData.map((item) => item[`NoHire`] || 0),
//         };
//       }
//     });
//   };

//   const options = {
//     chart: {
//       type: 'bar',
//       height: 380,
//       fontFamily: 'Inter var',
//       foreColor: '#000000',
//       toolbar: {
//         show: false,
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: true,
//         dataLabels: {
//           enabled: true,
//           position: 'center',
//         },
//         barHeight: '15px',
//       },
//     },
//     dataLabels: {
//       enabled: true,
//       style: {
//         fontSize: '10px',
//         colors: ['#fff'],
//       },
//     },
//     stroke: {
//       show: false,
//       width: 1,
//       colors: ['#fff'],
//     },
//     tooltip: {
//       shared: true,
//       intersect: false,
//     },
//     xaxis: {
//       categories: paginatedData.map((item) => item.title),
//       labels: {
//         show: false,
//       },
//       axisBorder: {
//         show: true,
//         color: '#9ca3af',
//         height: 1,
//       },
//     },
//     yaxis: {
//       axisBorder: {
//         show: true,
//         color: '#9ca3af',
//         width: 1,
//       },
//     },
//     grid: {
//       show: true,
//       borderColor: '#f3f4f6',
//       xaxis: {
//         lines: {
//           show: true,
//         },
//       },
//       yaxis: {
//         lines: {
//           show: true,
//         },
//       },
//     },
//     colors: ['#5EEE6E', '#F92D51'],
//   };

//   const setCountryId = (id) => {
//     setSelectedCountryId(id);
//   };

//   const setLocationId = (id) => {
//     setSelectedLocationId(id);
//   };

//   const setBranchId = (id) => {
//     setSelectedBranchId(id);
//   };

//   // Handle page changes
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   return (
//     <div>
//       <div className="flex justify-between  p-3">
//         <div>
//           <h1 className="text-black text-[16px] font-sans">{chartName}</h1>
//         </div>
//         <div>
//           <SelectCountryListByLocation
//             setCountryId={setCountryId}
//             setLocationId={setLocationId}
//             setBranchId={setBranchId}
//             isDaysFilter={false}
//             showCountry={true}
//             showBranch={true}
//             showLocation={true}
//           />
//         </div>
//       </div>

//       {/* Chart */}
//       <ReactApexChart
//         options={options}
//         series={getSeriesData()}
//         type="bar"
//         height={380}
//         width={567}
//       />

//       {/* Pagination Buttons */}
//       <div className="flex justify-center mt-4">
//         <button
//           className={`px-3 py-1 mx-1 rounded ${currentPage === 1 ? 'bg-gray-400 text-white' : 'bg-green-500 text-white hover:bg-green-600'}`}
//           onClick={handlePreviousPage}
//           disabled={currentPage === 1} // Disable Previous button if on the first page
//         >
//           Previous
//         </button>
//         <button
//           className={`px-3 py-1 mx-1 rounded ${currentPage >= totalPages ? 'bg-gray-400 text-white' : 'bg-green-500 text-white hover:bg-green-600'}`}
//           onClick={handleNextPage}
//           disabled={currentPage >= totalPages} // Disable Next button if on the last page
//         >
//           Next
//         </button>
//       </div>

//       {/* Page Indicator */}
//       <div className="text-center mt-2">
//         Page {currentPage} of {totalPages}
//       </div>
//     </div>
//   );
// };

// export default InterviewHiringChart;

//pages are as the number 
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import SelectCountryListByLocation from '../../features/utils/SelectCountryListByLocation';
import { cleanObjectData } from '../../features/utils/Utils';
import { useInterviewHiringReportChartMutation } from '../../features/dashboard/dashboardApiSlice';

const InterviewHiringChart = () => {
  const [selectedCountryId, setSelectedCountryId] = useState(0);
  const [selectedLocationId, setSelectedLocationId] = useState(0);
  const [selectedBranchId, setSelectedBranchId] = useState(0);

  const [currentPage, setCurrentPage] = useState(1); // Current page
  const itemsPerPage = 5; // Items per page

  const [
    interviewChart,
    { data: interviewData, isLoading: interviewLoading },
  ] = useInterviewHiringReportChartMutation();

  useEffect(() => {
    callAPI();
  }, []);

  useEffect(() => {
    callAPI();
  }, [selectedCountryId, selectedLocationId, selectedBranchId]);

  const callAPI = () => {
    const data = {
      country_id: parseInt(selectedCountryId),
      location_id: parseInt(selectedLocationId),
      branch_id: parseInt(selectedBranchId),
    };
    const dataObj = cleanObjectData(data);
    interviewChart(dataObj);
  };

  const chartData = interviewData?.data || [];
  const chartName = 'Interview';

  const series = ['Hire', 'NoHire'];

  // Pagination logic: Slice the chart data based on the current page
  const getPaginatedData = (data) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  };

  const paginatedData = getPaginatedData(chartData);

  // Calculate the total number of pages
  const totalPages = Math.ceil(chartData.length / itemsPerPage);

    // Automatically go to the first page if the data has fewer pages than the current page
    useEffect(() => {
        if (currentPage > totalPages) {
          setCurrentPage(1); // Reset to the first page
        }
      }, [totalPages, currentPage]);

  // Get series data based on the paginated data
  const getSeriesData = () => {
    return series.map((seriesName, index) => {
      if (index === 0) {
        return {
          name: seriesName,
          data: paginatedData.map((item) => item[`Hire`] || 0),
        };
      }
      if (index === 1) {
        return {
          name: seriesName,
          data: paginatedData.map((item) => item[`NoHire`] || 0),
        };
      }
    });
  };

  const options = {
    chart: {
      type: 'bar',
      height: 380,
      fontFamily: 'Inter var',
      foreColor: '#000000',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          enabled: true,
          position: 'center',
        },
        barHeight: '15px',
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '10px',
        colors: ['#fff'],
      },
    },
    stroke: {
      show: false,
      width: 1,
      colors: ['#fff'],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: paginatedData.map((item) => item.title),
      labels: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: '#9ca3af',
        height: 1,
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
        color: '#9ca3af',
        width: 1,
      },
    },
    grid: {
      show: true,
      borderColor: '#f3f4f6',
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    colors: ['#5EEE6E', '#F92D51'],
  };

  const setCountryId = (id) => {
    setSelectedCountryId(id);
  };

  const setLocationId = (id) => {
    setSelectedLocationId(id);
  };

  const setBranchId = (id) => {
    setSelectedBranchId(id);
  };

  // Handle page click
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons with numbers
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`px-2 mx-1 rounded ${currentPage === i ? 'bg-green-500 text-white' : 'bg-gray-200 text-black hover:bg-green-500 hover:text-white'}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      <div className="flex justify-between p-3">
        <div>
          <h1 className="text-black text-[16px] font-sans">{chartName}</h1>
        </div>
        <div>
          <SelectCountryListByLocation
            setCountryId={setCountryId}
            setLocationId={setLocationId}
            setBranchId={setBranchId}
            isDaysFilter={false}
            showCountry={true}
            showBranch={true}
            showLocation={true}
          />
        </div>
      </div>

      {/* Chart */}
      <ReactApexChart
        options={options}
        series={getSeriesData()}
        type="bar"
        height={380}
        width={567}
      />

      {/* Pagination Buttons */}
      <div className="flex justify-center">
        {renderPageNumbers()}
      </div>

      {/* Page Indicator */}
      {/* <div className="text-center mt-2">
        Page {currentPage} of {totalPages}
      </div> */}
    </div>
  );
};

export default InterviewHiringChart;



